import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { EditProject, Project, ProjectDetails, ServerResponse } from '@models';
import { ModalSuccessService } from '@modules';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalGenerateProjectService {
  private project = environment.PROJECTS;

  public response: Subject<boolean> = new Subject<boolean>();
  public statusProjectsList: Subject<boolean> = new Subject<boolean>();
  public edit: Subject<boolean> = new Subject<boolean>();
  public editedProject: ProjectDetails;

  constructor(
    private readonly http: HttpClient,
    private modalSuccess: ModalSuccessService
  ) {}

  public continue(): void {
    this.response.next(true);
  }

  public close(): void {
    this.response.next(false);
  }

  /**
   * Set project list status
   * @param status list status
   */
  public projectsList(status: boolean): void {
    this.statusProjectsList.next(status);
  }

  /**
   * Post create project
   * @param params Object with selected data for project creation
   */
  public postCreateProject(
    data: Project,
    showModal: boolean
  ): Observable<ServerResponse> {
    if (showModal) {
      this.modalSuccess.modal.next(true);
      this.modalSuccess.button.next('Cerrar');
    }
    const options = {
      withCredentials: true,
    };

    return this.http.post<ServerResponse>(this.project.PROJECT, data, options);
  }

  /**
   * Edit an existing project
   * @param data edited project
   * @param id project id
   */
  public putProject(data: EditProject, id: string): Observable<{}> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');
    const options = {
      withCredentials: true,
    };
    const path = this.project.EDIT.replace('{projectId}', id);
    return this.http.put(path, data, options);
  }
}
